(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ayla-ring-guide-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('AylaRingGuideDialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    let opener;
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-ayla-ring-guide-open]');
      if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      opener = trigger;
      dialog.showModal();
    });
    dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    const link = document.querySelector('[data-ayla-ring-guide-trigger]');
    const options = document.querySelector('.productView-options .product-form__input:last-of-type') || document.querySelector('.productView-options');
    const title = document.querySelector('.productView-title');
    if (link && options) options.after(link);
    else if (link && title) title.after(link);
  })();
  } catch(e) { console.error(e); }
})();

})();
